import { Box, keyframes, styled } from "@mui/material";

export const StyledWaitingNode = styled(Box)(({ theme }) => ({
  width: "100%",
  position: "absolute",
  top: 0,
  left: 0,
  height: "10px",
  display: "flex",
  ".sliderContainer": {
    width: "100%",
    height: "100%",
    ".slider": {
      height: "100%",
      background: theme.color.main,
      animation: `${slideRight} 1.5s ease-in-out infinite`,
    },
  },
  ".right": {
    display: "flex",
    justifyContent: "flex-end",
  },
}));

const slideRight = keyframes`
  0% {
    width: 0%;
    opacity: 0;
  }
50% {
 width: 100%;
 opacity: 1;
}
  100% {
    width: 0%;
    opacity: 0;
  }
`;
